module.exports = __webpack_public_path__ + "static/media/hosting_action_bg.de1eea4b.png";